export default __webpack_public_path__ + "57a71f7fc32c1e818cbc22c183a0060b.svg";